import { Navigate } from 'react-router-dom';
import { useSelector } from 'src/store/Store';
import { getRoleHomePath } from 'src/utils/roles';

const IndexRedirect = () => {
  const { role } = useSelector((state) => state.auth);

  return <Navigate to={getRoleHomePath(role)} replace />;
};

export default IndexRedirect;
